import React from 'react';
import { motion } from 'framer-motion';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 24
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-60px'
  },
  transition: {
    duration: 0.5,
    ease: 'easeOut'
  }
};
export function EmotionalSection() {
  return <section className="w-full px-5 py-16 md:py-24 bg-[#F5F0EA]" data-id="element-17">
      <div className="max-w-3xl mx-auto" data-id="element-18">
        <motion.h2 {...fadeInUp} className="text-2xl md:text-4xl font-semibold text-[#2C2825] mb-12 text-center" data-id="element-19">
          Si esto te suena, no estás sola
        </motion.h2>

        <div className="space-y-5" data-id="element-20">
          <motion.blockquote {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.05
        }} className="border-l-2 border-[#C4956A]/40 pl-5 py-2" data-id="element-21">
            <p className="text-[#2C2825]/80 italic text-[15px] md:text-base leading-relaxed" data-id="element-22">
              Te miras al espejo por la mañana y lo primero que ves son tus
              ojeras.
            </p>
          </motion.blockquote>

          <motion.blockquote {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.1
        }} className="border-l-2 border-[#C4956A]/40 pl-5 py-2" data-id="element-23">
            <p className="text-[#2C2825]/80 italic text-[15px] md:text-base leading-relaxed" data-id="element-24">
              En las fotos siempre pareces más cansada de lo que estás.
            </p>
          </motion.blockquote>

          <motion.blockquote {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.15
        }} className="border-l-2 border-[#C4956A]/40 pl-5 py-2" data-id="element-25">
            <p className="text-[#2C2825]/80 italic text-[15px] md:text-base leading-relaxed" data-id="element-26">
              Has probado contornos de ojos, rodillos, parches fríos… y nada
              cambia de verdad.
            </p>
          </motion.blockquote>

          <motion.blockquote {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.2
        }} className="border-l-2 border-[#C4956A]/40 pl-5 py-2" data-id="element-27">
            <p className="text-[#2C2825]/80 italic text-[15px] md:text-base leading-relaxed" data-id="element-28">
              El corrector se acumula en los pliegues y a media mañana ya se
              nota todo.
            </p>
          </motion.blockquote>

          <motion.blockquote {...fadeInUp} transition={{
          ...fadeInUp.transition,
          delay: 0.25
        }} className="border-l-2 border-[#C4956A]/40 pl-5 py-2" data-id="element-29">
            <p className="text-[#2C2825]/80 italic text-[15px] md:text-base leading-relaxed" data-id="element-30">
              Sientes que tu cara no refleja cómo te sientes por dentro.
            </p>
          </motion.blockquote>
        </div>

        <motion.p {...fadeInUp} transition={{
        ...fadeInUp.transition,
        delay: 0.3
      }} className="mt-10 text-center text-[#2C2825] font-semibold text-base md:text-lg leading-relaxed" data-id="element-31">
          No es que no te cuides. Es que nadie te ha explicado qué tipo de ojera
          tienes ni qué necesita exactamente.
        </motion.p>
      </div>
    </section>;
}